module.exports = __webpack_public_path__ + "img/rang1.3be6257f.png";